/* eslint-disable import/prefer-default-export */
import apiClient from './apiClient';
import { RESTAURANT_DESIGN_COLORS } from '../constants/UriConstants';
import {
  RestaurantColorSettingsInterface,
  RestaurantColorSettingsResponseInterface
} from '../types/RestaurantTypographyInterface';

export const getRestaurantColorSettings = (): Promise<RestaurantColorSettingsResponseInterface> =>
  apiClient.get(RESTAURANT_DESIGN_COLORS).then((response) => response.data);

export const saveRestaurantColorSettings = (
  colors: RestaurantColorSettingsInterface
): Promise<RestaurantColorSettingsResponseInterface> =>
  apiClient.put(RESTAURANT_DESIGN_COLORS, colors).then((response) => response.data);
